export default __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Bold.9a610369.ttf";